var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "screen user-subscriptions", attrs: { id: "first_screen" } },
    [
      _c("div", [_vm._v(" ")]),
      _vm._v(" "),
      _vm._l(_vm.subscriptions, function(sub) {
        return _c("div", { staticClass: "subscriptions" }, [
          _c("h2", [_vm._v(_vm._s(sub.plan) + " unlocked")]),
          _vm._v(" "),
          _c("p", [
            _vm._v("you can use button below to download app from App Store")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "apple-button-wrapper" }, [
            _c("a", { attrs: { target: "_blank", href: sub.install_url } }, [
              _c("img", {
                attrs: {
                  src: "/media/pulse-new/email/download-on-appstore.svg",
                  width: "200"
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "small" }, [
            _vm._v(
              "\n        You have subscribed at " +
                _vm._s(sub.created_at) +
                " with trial period until " +
                _vm._s(sub.trial_end) +
                "."
            ),
            _c("br"),
            _vm._v("\n        If you want to cancel subscriptions use "),
            _c(
              "a",
              {
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.cancel_subscription(sub)
                  }
                }
              },
              [_vm._v("this link")]
            ),
            _vm._v(".\n    ")
          ])
        ])
      }),
      _vm._v(" "),
      _c("div", [_vm._v(" ")])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }